import { SearchPayload } from "../../../search/SearchPayload"
import { InventoryLocationDto } from "../../location/models"

export type ImportElastic = {
    id: string
    identifier: string
    createdAt: string
	inventoryLocationId: string
    inventoryLocation: InventoryLocationDto
    type: string
    status: string
}

export type ImportItemsResult = {
    data: ImportElastic[]
    metadata: {
        pageSize: number
        activePage: number
        totalItemsCount: number
    }
}


export const HEADER_KEYS = ["id", "createdAt", "inventoryLocationId", "importType","status"]

export type ImportListingSearchPayload = Omit<SearchPayload, "lightResult" | "objects">


// WEBPACK FOOTER //
// ./src/state/inventory/imports/service/types.ts